
type GetOffsetCurriedFunction = (position: number) => number;

function getChangeString(val: number, oldVal: number): string {
    const difference = val - oldVal;
    const plusMinus = difference < 0 ? "-" : "+";
    return plusMinus + Math.abs(difference) + "pp";
}

function getOffSet(staticOffset: number, barWidth: number): GetOffsetCurriedFunction {
    return function (position: number): number {
        return position + barWidth - staticOffset;
    }
}

function getBarWidth(val: number): number {
    return 25 * 4 * (val / 100);
}

export function makeExpandedLabelValues(val: number, oldVal: number): {
    changeString: string,
    barWidthOld: number,
    barWidthNew: number,
    offsetOld: GetOffsetCurriedFunction,
    offsetNew: GetOffsetCurriedFunction,
    bgWidth: number,
} {
    const changeString = getChangeString(val, oldVal);
    const barWidthOld = getBarWidth(oldVal);
    const barWidthNew = getBarWidth(val);
    const offsetOld = getOffSet(30, barWidthOld);
    const offsetNew = getOffSet(42, barWidthNew);
    const bgWidth = getBarWidth(Math.max(val, oldVal)) + 148;

    return {
        changeString,
        barWidthOld,
        barWidthNew,
        offsetOld,
        offsetNew,
        bgWidth,
    };
}